import React, { useState } from 'react';
import { Star, ChevronRight } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';

const FeaturedSponsoredTeam = () => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  // Static NY Aces team photo - permanent URL
  const nyAcesPhotoUrl = "https://customer-assets.emergentagent.com/job_pbgear-social/artifacts/h94fhfw6_NY%20Aces%20%20Team%202.jpg";

  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-[#0a0b0c] via-[#0d0e10] to-[#0a0b0c] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header with animated accent */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="h-px w-12 bg-gradient-to-r from-transparent to-[#00d4aa]" />
          <div className="flex items-center gap-2">
            <Star className="h-5 w-5 text-[#00d4aa] animate-pulse" />
            <h2 className="text-white text-sm md:text-base font-bold uppercase tracking-[0.3em]">
              Featured Sponsored Team
            </h2>
            <Star className="h-5 w-5 text-[#00d4aa] animate-pulse" />
          </div>
          <div className="h-px w-12 bg-gradient-to-l from-transparent to-[#00d4aa]" />
        </div>

        {/* Main Feature Card */}
        <div 
          className="relative rounded-3xl overflow-hidden cursor-pointer group"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate('/gallery')}
        >
          {/* Animated Border Glow */}
          <div className="absolute -inset-0.5 bg-gradient-to-r from-[#00d4aa] via-[#00a896] to-[#00d4aa] rounded-3xl opacity-0 group-hover:opacity-100 blur-sm transition-opacity duration-500" />
          
          {/* Card Container */}
          <div className="relative bg-[#131416] rounded-3xl overflow-hidden">
            
            {/* Layout: Side by Side on Desktop */}
            <div className="flex flex-col lg:flex-row">
              
              {/* Left Side - Team Info Panel */}
              <div className="lg:w-2/5 p-8 md:p-12 flex flex-col justify-center relative z-10 bg-gradient-to-br from-[#131416] to-[#1a1b1e]">
                {/* Sponsor Badge */}
                <Badge className="w-fit bg-[#00d4aa] text-[#0a0b0c] font-bold px-4 py-2 text-sm mb-6 shadow-lg shadow-[#00d4aa]/20">
                  <Star className="h-4 w-4 mr-2" />
                  Official Sponsor
                </Badge>

                {/* NY Aces Logo */}
                <div className="w-28 h-32 md:w-36 md:h-40 rounded-2xl bg-black/40 backdrop-blur-sm border border-white/10 flex items-center justify-center p-3 mb-6 shadow-2xl overflow-hidden transform group-hover:scale-105 transition-transform duration-500">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_tactical-sports/artifacts/0c5nukgd_NY%20Aces%20Logo.jpg" 
                    alt="NY Aces Logo"
                    className="w-full h-full object-contain"
                  />
                </div>

                {/* Team Name */}
                <h3 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tight mb-3">
                  NY <span className="text-[#00d4aa]">Aces</span>
                </h3>
                
                <p className="text-white/60 mb-8 text-sm md:text-base">
                  Official GWINS Gear Sponsored Team
                </p>

                {/* CTA Button */}
                <Button
                  className="w-fit bg-[#00d4aa] hover:bg-[#33e0bb] text-[#0a0b0c] font-bold rounded-full px-8 py-6 text-lg shadow-lg shadow-[#00d4aa]/30 transform group-hover:translate-x-2 transition-all duration-300"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/gallery');
                  }}
                >
                  View Team Media
                  <ChevronRight className="ml-2 h-5 w-5" />
                </Button>
              </div>

              {/* Right Side - Hero Image */}
              <div className="lg:w-3/5 relative min-h-[250px] md:min-h-[400px]">
                {/* Background Image */}
                <img
                  src={nyAcesPhotoUrl}
                  alt="NY Aces Team in Action"
                  className="absolute inset-0 w-full h-full object-cover object-center lg:object-top transform group-hover:scale-105 transition-transform duration-700"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Accent Line */}
        <div className="flex justify-center mt-8">
          <div className="h-1 w-32 bg-gradient-to-r from-transparent via-[#00d4aa] to-transparent rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default FeaturedSponsoredTeam;
